<template>
    <v-container grid-list-md v-if="sample">
        <v-card-title>
            <CreateComponent :id="sample.id" v-on:created="getProducts()"></CreateComponent>
            <v-btn v-if="sample.track_number">Track number : {{ sample.track_number }}</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="products.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <tr :class="{ 'light-green accent-1': props.item.sent }">
                    <td class="text-xs">{{ props.item.lc_code }}</td>
                    <td class="text-xs">{{ props.item.ftn_code }}</td>
                    <td class="text-xs">{{ props.item.name }}</td>
                    <td class="text-xs">{{ props.item.application_name }}</td>
                    <td class="text-xs">{{ props.item.project_name }}</td>
                    <td class="text-xs">{{ props.item.priority_name }}</td>
                    <td class="layout px-0 align-center">
                        <v-menu
                                transition="slide-y-transition"
                                bottom
                                left
                        >
                            <v-btn
                                    slot="activator"
                                    color="primary"
                                    dark
                                    icon
                                    flat
                            >
                                <v-icon>settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile>
                                    <EditProductComponent :sample_order_id="sample.id" :product="props.item"></EditProductComponent>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>delete</v-icon>Delete</v-btn>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <FeedbackComponent :sample_order_line="props.item" :sample_order_id="sample.id"></FeedbackComponent>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="products.meta">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ products.meta.from }} to {{ products.meta.to }} of {{ products.meta.total }} entries</p>
        </div>
        <br>
        <CommentComponent :sample="sample"></CommentComponent>
    </v-container>
</template>

<script>
    import CommentComponent from './components/CommentComponent';
    import CreateComponent from './components/CreateProductComponent';
    import FeedbackComponent from './components/FeedbackComponent';
    import EditProductComponent from './components/EditProductComponent';

    export default {
        props: ['sample'],
        data: function () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                headers: [
                    {
                        text: 'LC Code',
                        align: 'left',
                        sortable: false,
                        value: 'code'
                    },
                    { text: 'Supplier Code/Reference', value: 'product', sortable: false },
                    { text: 'Product', value: 'units', sortable: false },
                    { text: 'Application', value: 'pricekg', sortable: false },
                    { text: 'Type of project', value: 'price', sortable: false },
                    { text: 'Priority', value: 'date', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                products: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created () {
            this.debouncedGetProducts = _.debounce(this.getProducts, 500)
            this.getProducts();
        },
        watch: {
            sample: function () {
                this.getProducts();
            },
            search: function () {
                this.loading = true;
                this.debouncedGetProducts();
            },
            last_page: function () {
                if (this.page > this.products.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteSampleOrderLines', {
                            sample_id: this.sample.id,
                            sample_order_line_id: id
                        }).then((res) => {

                            this.getProducts();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getProducts();
            },
            getProducts () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        id: this.sample.id
                    },
                    id: this.sample.id
                };
                this.$store.dispatch('getSampleOrderLines', params).then((res) => {

                    this.products = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
        },
        components: {
            CommentComponent,
            CreateComponent,
            FeedbackComponent,
            EditProductComponent
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/views/InfoComponent.vue